import { gate } from 'hub-http/gates';
import { useHasGate } from './useHasGate';
import { VIEWS_NAMESPACE_NONE } from '../../viewsSearch/constants';
const VIEWS_V2_GATE = gate('CRM:Datasets:ViewsV2');
export const useHasViewsV2Gate = () => {
  const {
    loading,
    data
  } = useHasGate(VIEWS_V2_GATE);
  return !loading && Boolean(data);
};
export const useHasViewsV2 = namespaceName => {
  const hasGate = useHasViewsV2Gate();
  return hasGate && namespaceName === VIEWS_NAMESPACE_NONE;
};